export var Codecs;
(function (Codecs) {
    Codecs["NONE"] = "None";
    Codecs["SCALAR"] = "Scalar";
    Codecs["ANGLE"] = "Angle";
    Codecs["LEVEL"] = "Level";
})(Codecs || (Codecs = {}));
